declare namespace $ {

	type $mol_view__sub_rise_devtools_selector_overlay_files_1 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['actions_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_rise_devtools_selector_overlay_files_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_rise_devtools_selector_overlay_files_3 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['file_open_view_tree'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_rise_devtools_selector_overlay_files_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_rise_devtools_selector_overlay_files_5 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['file_open_view_ts'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_rise_devtools_selector_overlay_files_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_rise_devtools_selector_overlay_files_7 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['file_open_view_css_ts'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_rise_devtools_selector_overlay_files_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_rise_devtools_selector_overlay_files_9 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['file_save'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_textarea__value_rise_devtools_selector_overlay_files_10 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay_files['file_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__highlight_rise_devtools_selector_overlay_files_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['highlight'] >
	>
	type $mol_view__sub_rise_devtools_selector_overlay_files_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $rise_devtools_selector_overlay_files extends $mol_view {
		content( ): readonly(any)[]
		actions_content( ): readonly(any)[]
		file_open_view_tree( next?: any ): any
		file_open_view_ts( next?: any ): any
		file_open_view_css_ts( next?: any ): any
		file_save( next?: any ): any
		file_text( next?: string ): string
		file_error( next?: string ): string
		rpc_port( ): string
		target_info( ): any
		file_path( next?: string ): string
		editor_opened( next?: boolean ): boolean
		sub( ): ReturnType< $rise_devtools_selector_overlay_files['content'] >
		Actions( ): $mol_view
		Open_view_tree( ): $mol_button_minor
		Open_view_ts( ): $mol_button_minor
		Open_view_css_ts( ): $mol_button_minor
		Save_file( ): $mol_button_minor
		Editor( ): $mol_textarea
		Error( ): $mol_view
	}
	
}

//# sourceMappingURL=files.view.tree.d.ts.map